import React from "react";
import {
  MOBILE_JADWAL_TELEKONSUL,
  MOBILE_PEMBAYARAN_TELEKONSUL,
  MOBILE_PEMBELIAN_TELEKONSUL,
  MOBILE_TARIF_TELEKONSUL,
  MOBILE_USER,
  MOB_FAQ,
  MOB_SLIDER,
} from "App/constants";
import {
  Faq,
  JadwalDokterTelekonsul,
  MobileMemberList,
  PembayaranTelekonsul,
  PembelianTelekonsul,
  Slider,
  TarifDokterTelekonsul,
} from "../WrapperLazyExport";

export const menuMobile = {
  [MOBILE_USER]: <MobileMemberList />,
  [MOB_FAQ]: <Faq />,
  [MOB_SLIDER]: <Slider />,
  [MOBILE_JADWAL_TELEKONSUL]: <JadwalDokterTelekonsul />,
  [MOBILE_TARIF_TELEKONSUL]: <TarifDokterTelekonsul />,
  [MOBILE_PEMBELIAN_TELEKONSUL]: <PembelianTelekonsul />,
  [MOBILE_PEMBAYARAN_TELEKONSUL]: <PembayaranTelekonsul />,
};
